import gift from 'widgets/functions/gift/gift';
import animate from 'widgets/functions/animation/animate';

import assign from 'lodash/assign';
import roomLib from '../room';

const handle = (socket) => {
  // 礼物动画
  socket.on('gift.animation', (msg, { room, users }, { messages }) => {
    const { data_d: data } = msg;

    data.gift = assign(data.gift, gift.getGift(data.gift._id));
    animate.push(data);
  });
  socket.on('gift.notify', (msg, { room, users }, { messages }) => {
    const { roomId } = room;
    const { data_d: data } = msg;

    if (data.from) {
      data.from.isMicStar = roomLib.isMicStar(data.from._id);
      users.add(data.from);
    }
    if (data.to) {
      data.to.isMicStar = roomLib.isMicStar(data.to._id);
      users.add(data.to);
    }

    data.gift = assign(data.gift, gift.getGift(data.gift._id));

    messages.add({
      msg,
      msgType: data.gift.pay_level ? 'payLevelGift' : 'gift',
      tabType: 'gift',
    });

    animate.push(data);

    // 幸运礼物处理
    if (!data.win_coin || data.win_coin.length === 0) {
      return;
    }

    data.times = data.win_coin.reduce((prev, val) => val + prev, 0);
    messages.add({
      msg,
      msgType: 'luckGift',
      tabType: 'gift',
    });
  });
};

export default handle;
